export const IN_USE_DESTINATIONS_SHORT_LIST_MAX_LENGTH = 3;
